module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIAQAAAAB9lo7qAAAAAnRSTlMAAHaTzTgAAAAkSURBVHgBYxhUgPn/Hwb7/wfIY30AEvy0ZA0QoIffKAr7wQQAm4BS+X0wREQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sdks/agora/assets/full-screen.png
// module id = 1340
// module chunks = 0